export default __webpack_public_path__ + "static/media/trud_vsem-icon.37dda602.svg";